/* Affy wishlist — client-side via localStorage.
   Card hearts ([data-wish]) toggle + persist; header heart ([data-wish-open]) opens a drawer. */
(function () {
  var KEY = 'affy_wishlist_v1';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} paintCount(); }
  function ids() { return read().map(function (i) { return String(i.id); }); }

  function paintCount() {
    var n = read().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  function paintHearts() {
    var have = ids();
    document.querySelectorAll('[data-wish]').forEach(function (b) {
      var on = have.indexOf(String(b.getAttribute('data-wish-id'))) > -1;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function toggle(btn) {
    var id = btn.getAttribute('data-wish-id'), list = read();
    var i = list.findIndex(function (x) { return String(x.id) === String(id); });
    if (i > -1) list.splice(i, 1);
    else list.push({
      id: id, url: btn.getAttribute('data-wish-url'), title: btn.getAttribute('data-wish-title'),
      img: btn.getAttribute('data-wish-img'), price: btn.getAttribute('data-wish-price')
    });
    write(list); paintHearts();
    if (document.querySelector('[data-wish-drawer].open')) renderDrawer();
  }

  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function renderDrawer() {
    var wrap = document.querySelector('[data-wish-items]'); if (!wrap) return;
    var list = read();
    if (!list.length) {
      wrap.innerHTML = '<p class="wishd__empty">Your wishlist is empty.<br>Tap the ♡ on any bouquet to save it here.</p>';
      return;
    }
    wrap.innerHTML = list.map(function (i) {
      return '<div class="wishd__item">' +
        '<a href="' + esc(i.url) + '" class="wishd__media">' + (i.img ? '<img src="' + esc(i.img) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="wishd__info">' +
          '<a href="' + esc(i.url) + '" class="wishd__name">' + esc(i.title) + '</a>' +
          '<div class="wishd__price">' + esc(i.price) + '</div>' +
          '<div class="wishd__act"><a class="btn btn--sm" href="' + esc(i.url) + '">View</a>' +
          '<button type="button" class="wishd__rm" data-wish-remove="' + esc(i.id) + '">Remove</button></div>' +
        '</div></div>';
    }).join('');
  }

  function open() {
    var d = document.querySelector('[data-wish-drawer]'); if (!d) return;
    renderDrawer(); d.classList.add('open'); d.setAttribute('aria-hidden', 'false');
    var s = document.querySelector('[data-wish-scrim]'); if (s) s.classList.add('on');
    document.documentElement.classList.add('wish-open');
  }
  function close() {
    var d = document.querySelector('[data-wish-drawer]'); if (!d) return;
    if (d.contains(document.activeElement)) { var o = document.querySelector('[data-wish-open]'); if (o) { try { o.focus(); } catch (e) {} } else if (document.activeElement.blur) document.activeElement.blur(); }
    d.classList.remove('open'); d.setAttribute('aria-hidden', 'true');
    var s = document.querySelector('[data-wish-scrim]'); if (s) s.classList.remove('on');
    document.documentElement.classList.remove('wish-open');
  }

  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-wish]');
    if (w) { e.preventDefault(); e.stopPropagation(); toggle(w); return; }
    if (e.target.closest('[data-wish-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-wish-close]') || e.target.closest('[data-wish-scrim]')) { close(); return; }
    var rm = e.target.closest('[data-wish-remove]');
    if (rm) {
      var id = rm.getAttribute('data-wish-remove');
      write(read().filter(function (x) { return String(x.id) !== String(id); }));
      paintHearts(); renderDrawer(); return;
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  paintHearts(); paintCount();
  document.addEventListener('DOMContentLoaded', function () { paintHearts(); paintCount(); });
  document.addEventListener('shopify:section:load', paintHearts);
})();
